"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
 * Email reegx Reference at https://gomakethings.com/email-validation-in-javascript/
 * */
var _default = {
  rejectEmpty: /\S/,
  dates: {
    splitDate: {
      // YYYY-MM-DD || YYYY - M - D || YYYY/MM/DD || YYYY / M / D
      regex: /([0-9]{1,4})?[-/]([0-9]{1,2})?[-/]([0-9]{1,2})?/
    }
  },
  email: {
    global: /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/
  },
  name: {
    //tests for a name with one of more words, forbidding some special characters
    global: /^[^!?$%#"€@&*_<>§«»+=()/|\\\d]+$/
  },
  preferredName: {
    global: /^$|^[^!?$%#"€@&*_<>§«»+=()/|\\\d]+$/
  },
  sessionName: {
    //tests for a name with one of more words, forbidding all special characters but . and -
    global: /^[A-Za-z0-9\.\-\_ \u00E1\u00C1\u00E0\u00C0\u00E3\u00C3 \u00E7\u00C7 \u00E9\u00C9\u00E8\u00C8\u00EA\u00CA \u00ED\u00CD\u00EC\u00CC\u00EE\u00CE \u00F3\u00D3\u00F2\u00D2\u00F4\u00D4\u00F5\u00D5 \u00FA\u00DA\u00F9\u00D9\u00FB\u00DB]+$/
  },
  username: {
    global: /^[a-zA-Z0-9._-]*$/
  },
  phone: {
    complete: /(.+)(\s?\/\/\s?)(.+)/,
    // Prefix//Number
    prefix: /^\+[0-9]+$/,
    number: /^[0-9]+$/,
    international: /^(\+)([0-9]+)(\/?\/?)([0-9]+)$/
  },
  ids: {
    member: /^[0-9a-zA-Z-]*$/
  },
  integers: {
    general: /(^-?[1-9]\d*$)|^0$|^\d*$/
  },
  floats: {
    general: /^[\-]?[0-9]*([.,]\d+)?$/
  },
  zipcode: {
    acceptedChars: /^([a-zA-Z0-9-])*$/
  },
  url: {
    general: /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)$/
  }
};
exports["default"] = _default;